import i18next from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useGetCurrentUserTags, useRiskThemes } from "../api/hooks/useRiskThemes";
import { ButtonDropdown } from "../components/buttonDropdownYears";
import { RiskList } from "../components/riskList";
import { useAdmin } from "../context/adminContext";
import { useDesignSystem } from "../context/designSystemContext";
import {
  defaultFilterTypeNumber,
  defaultSelectFilterType,
} from "../types/selectFilter";
import { canCreateRisk as getCanCreateRisk } from "../utils/canCreateRisk";

export const Home = () => {
  const [year, setYear] = useState<defaultFilterTypeNumber>({
    value: new Date().getFullYear(),
    label: new Date().getFullYear(),
  });
  const [priorityFilter, setPriorityFilter] = useState<
    defaultSelectFilterType[]
  >([]);

  const { error, data: allRisks } = useRiskThemes(
    year.value,
    priorityFilter?.map((option: defaultSelectFilterType) => option.value)
  );
  const { designSystem } = useDesignSystem();
  
  const isAdmin = useAdmin();
  const { data: currentUserTags } = useGetCurrentUserTags();
  const canCreateRisk = getCanCreateRisk({ isAdmin, currentUserTags });

  useTranslation();

  return (
    <div className="h-screen flex flex-col">
      <div className="flex justify-between">
        <div className="mx-5 mt-4 mb-3 font-openSans font-bold text-xl w-1/2" style={{ color: designSystem?.cssBasics.primaryColor }}>
          {i18next.t("home_tittle")}
        </div>

        {!error ? (
          <ButtonDropdown
            year={year}
            setYear={setYear}
            priorityFilter={priorityFilter}
            setPriorityFilter={setPriorityFilter}
          />
        ) : (
          <p>{i18next.t("error_loading_years")}</p>
        )}
      </div>

      <div
        className="flex-grow overflow-y-auto custom-scrollbar"
        style={{ height: "80vh", paddingBottom: "4rem" }}
      >
        <RiskList riskData={allRisks ? allRisks : []} />
      </div>

      {canCreateRisk && <div className="w-full justify-end grid pr-7 fixed bottom-4 right-4">
        {" "}
        {/* Ajustado para bottom-4 e right-4 */}
        <Link
          to="/add_risk"
          className="flex text-white py-0.5 px-2 rounded px-6 py-2 font-openSans font-sans text-[14px] font-semibold leading-[14.98px] text-center"
          style={{ backgroundColor: designSystem?.cssBasics.secondaryColor }}
        >
          {i18next.t("add_risk")}
        </Link>
      </div>}
    </div>
  );
};
